export default {
  headerColor: Styles.color.grey.one,
};
